import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../modules';
import { setMarkedToolbar } from '../../../modules/editor';
import { ContentsItem } from '../../../modules/editor/types';

// 에디트 모듈
import CtaEdit from '../Edit/CtaEdit';

type Props = {
	contentItem: ContentsItem
};

function Donation({ contentItem }: Props) {
	const dispatch = useDispatch();
	
	const markedToolbar = useSelector((state: RootState) => state.editor.markedToolbar);

	const markToolbar = (contentId: number, currentIndex: number, itemType:string) => {
		dispatch(setMarkedToolbar({
			contentId: contentId,
			currentIndex: currentIndex,
			itemType: itemType
		}))
	}

	const columnPadding = () => {
		return {
			paddingLeft: contentItem.content.style[0].box?.paddingLeft,
			paddingRight: contentItem.content.style[0].box?.paddingRight,
			paddingTop: contentItem.content.style[0].box?.paddingTop,
			paddingBottom: contentItem.content.style[0].box?.paddingBottom,
		}
	}

	return (
		<>
			{
				contentItem.content.column.map((column: string[], index: number) => (
					<div
						key={index}
						className={`content-column column-index-${index}`}
						style={columnPadding()}
					>
						{
							column.map((row: string, subIndex: number) => (
								<div
									key={subIndex}
								>
									{row === 'cta' && (
										<CtaEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].button}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
								</div>
							))
						}
					</div>
				))
			}
		</>
	)
}

export default Donation;